<template>
  <div class="a-timer" v-if="value > 0">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.477 0 0 4.478 0 10C0 15.523 4.477 20 10 20C15.522 20 20 15.522 20 10C20 4.478 15.522 0 10 0ZM10 19C5.029 19 1 14.971 1 10C1 5.03 5.029 1 10 1C14.971 1 19 5.03 19 10C19 14.971 14.971 19 10 19ZM15.5 10H10V4.5C10 4.224 9.776 4 9.5 4C9.224 4 9 4.224 9 4.5V10.5C9 10.776 9.224 11 9.5 11H15.5C15.776 11 16 10.776 16 10.5C16 10.224 15.776 10 15.5 10Z" fill="#E30613"/>
    </svg>
    <div class="a-timer__item" v-if="days">
      <span class="days">{{days}}</span>
      <i>дн.</i>
    </div>
    <div class="a-timer__item" v-if="hours">
      <span class="hours">{{hours}}</span>
      <i>чac.</i>
    </div>
    <div class="a-timer__item">
      <span class="minutes">{{minutes}}</span>
      <i>мин.</i>
    </div>
    <div class="a-timer__item">
      <span class="seconds">{{seconds}}</span>
      <i>сек.</i>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: Number
    },

    computed: {
      days() {
        return Math.trunc(this.value / 3600 / 24);
      },

      hours() {
        return Math.trunc(this.value / 3600) % 24;
      },

      minutes() {
        return Math.trunc(this.value / 60) % 60;
      },

      seconds() {
        return this.value % 60;
      }
    }
  }
</script>

<style scoped>

</style>
